import qwest from 'qwest';

let CustomerContactApi = {
  save(contact) {
    return new Promise((resolve, reject) => {
      qwest.post('/CustomerContact', contact.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            resolve(response);
          } else {
            reject(response);
          }
        });
    });
  },
};

export default CustomerContactApi;
